import { PropsWithChildren } from "react";
import clsx from "clsx";

import { footerStyles } from "./footer.styles";

interface FooterProps {
  className?: string;
}

export const Footer = ({
  children,
  className,
}: PropsWithChildren<FooterProps>) => {
  const classes = footerStyles();

  return (
    <footer className={clsx(classes.footer, className)}>{children}</footer>
  );
};

Footer.defaultProps = {
  className: "",
};
